module.exports = [{"type":"title","text":"2025-02-10"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：‘查詢當前全部掛單’接口增加actPrice字段。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-02-10.json
// module id = lKCo
// module chunks = 3